





































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SeasonRuleForm'

  vue:
    props: ['calendar']

    methods:
      hiAddSeason: ->
        @calendar.seasons.push
          id: Math.floor(Math.random() * 100)
          name: "Season #{@calendar.seasons.length + 1}"
          starts_at: null
          ends_at: null

      hiRemoveSeason: (id) ->
        @calendar.seasons = @calendar.seasons.filter((season) -> season.id isnt id)

export default VueOptions.vue settings
